export default __webpack_public_path__ + "static/media/cross.6db25e55.jpg";